'use client';
import { ILocationDropDown, ISmallArea } from '@/hook';
import { useEffect, useState } from 'react';
import { StepperLocationDropdown } from '@/components/sell-car-form';

import { SearchIcon } from '../../../../../public/Images';
import { ICoordinate, IRegion_SELL } from '@/types';
import styles from './styles.module.scss';
import Image from 'next/image';

const LocationFormContentOriginal = ({
    formContent,
    formFunction,
    step,
    open,
    searchPlaceholder,
    intialValue,
}: {
    formContent: ILocationDropDown[];
    step: 'region';
    formFunction: (key: 'region', clickedItem: IRegion_SELL) => void;
    open: boolean;
    searchPlaceholder: string;
    intialValue: ISmallArea;
}) => {
    const [formContentState, setFormContentState] = useState(formContent);
    const [formFilteredContentState, setFormFilteredContentState] =
        useState(formContent);

    const [search, setSearch] = useState('');

    const searchFor = (input: string) => {
        const trimmedInput = input.trim();
        if (trimmedInput === '') {
            setFormFilteredContentState(formContentState);
            setSearch(input);
            return;
        }
        const filteredArr = formContentState?.map(region => {
            const smallArea = region.smallArea.filter(
                smallRegion =>
                    smallRegion?.nameEn
                        .toLocaleLowerCase()
                        .includes(trimmedInput.toLocaleLowerCase()) ||
                    smallRegion?.nameAr
                        .toLocaleLowerCase()
                        .includes(trimmedInput.toLocaleLowerCase())
            );

            return { ...region, smallArea, expanded: true };
        });
        const unique = filteredArr.filter(
            item =>
                item?.bigAreaEn !== 'Top Areas' && item?.smallArea.length !== 0
        );

        setFormFilteredContentState(unique);
        setSearch(input);
    };
    const setIntialData = () => {
        const filteredArr = formContent?.map(region => {
            const smallArea = region.smallArea.map(smallRegion => {
                return {
                    ...smallRegion,
                    selected:
                        intialValue.nameEn === smallRegion.nameEn ||
                        intialValue.nameAr === smallRegion.nameAr,
                };
            });

            return { ...region, smallArea, expanded: true };
        });
        setFormContentState(filteredArr);
        setFormFilteredContentState(filteredArr);
    };
    useEffect(() => {
        setIntialData();
    }, [formContent]);

    const sendLocationObj = (
        bigArea: { en: string; ar: string },
        smallArea: ISmallArea,
        id: string
    ) => {
        const obj: IRegion_SELL = {
            id: id,
            bigArea: bigArea.en,
            smallArea: smallArea.nameEn,
            name: smallArea.nameEn,
            bigAreaAr: bigArea.ar,
            smallAreaAr: smallArea?.nameAr,
            address: '',
            addressCity: '',
            coordinate: { lat: 0, lng: 0 },
            polygon: [],
            serviceable: false,
            warehouse: false,
            sendPinLocation: false,
        };
        formFunction(step, obj);
    };
    const buttonClicked = (id: string, value: string) => {
        let tempLocationObject = {
            bigArea: { en: '', ar: '' },
            smallArea: {
                id: '',
                nameEn: '',
                nameAr: '',
                selected: false,
                showAlert: false,
                polygon: [] as ICoordinate[],
                serviceable: false,
                warehouse: false,
            },
            id: '',
        };
        const newState = formContentState.map(location => {
            const smallAreas = location.smallArea.map(smallArea => {
                const area: ISmallArea = {
                    ...smallArea,
                    selected:
                        value === smallArea.nameEn ||
                        value === smallArea?.nameAr,
                };
                if (value === smallArea?.nameEn || value === smallArea?.nameAr)
                    tempLocationObject = {
                        bigArea: {
                            en: location.bigAreaEn,
                            ar: location.bigAreaAr,
                        },
                        smallArea,
                        id,
                    };
                return area;
            });
            return {
                ...location,
                expanded: false,
                smallArea: [...smallAreas],
            };
        });
        const newFiltredState = formFilteredContentState.map(location => {
            let expanded = false;
            const smallAreas = location.smallArea.map(smallArea => {
                const area: ISmallArea = {
                    ...smallArea,
                    selected:
                        value === smallArea.nameEn ||
                        value === smallArea?.nameAr,
                };
                if (
                    value === smallArea?.nameEn ||
                    value === smallArea?.nameAr
                ) {
                    tempLocationObject = {
                        bigArea: {
                            en: location.bigAreaEn,
                            ar: location.bigAreaAr,
                        },
                        smallArea,
                        id,
                    };
                    expanded = true;
                }
                return area;
            });
            return {
                ...location,
                expanded: expanded,
                smallArea: [...smallAreas],
            };
        });
        sendLocationObj(
            {
                en: tempLocationObject.bigArea.en,
                ar: tempLocationObject.bigArea.ar,
            },
            tempLocationObject.smallArea,
            tempLocationObject.id
        );
        setFormContentState(newState);
        setFormFilteredContentState(newFiltredState);
    };
    return (
        <>
            <div className={styles.search_group}>
                <Image
                    src={SearchIcon.src}
                    width={SearchIcon.width}
                    height={SearchIcon.height}
                    style={{ position: 'absolute', zIndex: 1, bottom: '38%' }}
                    alt=" search"
                />
                <input
                    className={styles.search_input}
                    value={search}
                    onChange={e => searchFor(e.target.value)}
                    placeholder={searchPlaceholder}
                />
            </div>
            <section
                className={`${styles.options_container} ${
                    open ? styles.open : ''
                }`}
            >
                {formFilteredContentState?.map(location => (
                    <StepperLocationDropdown
                        key={location?.id}
                        location={location}
                        buttonClicked={buttonClicked}
                    />
                ))}
            </section>
        </>
    );
};
export default LocationFormContentOriginal;
